// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolOperationTemplateId } from './HarvestProtocolOperationTemplate';
import { harvestOperationTemplateAttributeId } from './HarvestOperationTemplateAttribute';
import { z } from 'zod';
export const harvestProtocolOpControlPointSettingId = (z.number());
export const harvestProtocolOpControlPointSetting = z.object({
    id: harvestProtocolOpControlPointSettingId,
    protocol_op_template_id: harvestProtocolOperationTemplateId,
    template_attribute_id: harvestOperationTemplateAttributeId,
    number_target: z.string().nullable(),
    number_rel_tol_upper: z.string().nullable(),
    number_rel_tol_lower: z.string().nullable(),
    number_abs_tol_upper: z.string().nullable(),
    number_abs_tol_lower: z.string().nullable(),
    number_unit: z.string().nullable(),
    check_value: z.boolean().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
});
export const harvestProtocolOpControlPointSettingInitializer = z.object({
    id: harvestProtocolOpControlPointSettingId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId,
    template_attribute_id: harvestOperationTemplateAttributeId,
    number_target: z.string().optional().nullable(),
    number_rel_tol_upper: z.string().optional().nullable(),
    number_rel_tol_lower: z.string().optional().nullable(),
    number_abs_tol_upper: z.string().optional().nullable(),
    number_abs_tol_lower: z.string().optional().nullable(),
    number_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
export const harvestProtocolOpControlPointSettingMutator = z.object({
    id: harvestProtocolOpControlPointSettingId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId.optional(),
    template_attribute_id: harvestOperationTemplateAttributeId.optional(),
    number_target: z.string().optional().nullable(),
    number_rel_tol_upper: z.string().optional().nullable(),
    number_rel_tol_lower: z.string().optional().nullable(),
    number_abs_tol_upper: z.string().optional().nullable(),
    number_abs_tol_lower: z.string().optional().nullable(),
    number_unit: z.string().optional().nullable(),
    check_value: z.boolean().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
});
//# sourceMappingURL=HarvestProtocolOpControlPointSetting.js.map